import type { Row } from '@/lib/qcp/protocol';

/** Map a Row string to the OfcRow display label. */
export function rowToLabel(row: Row): 'TOP' | 'MID' | 'BOT' {
  switch (row) {
    case 'front':  return 'TOP';
    case 'middle': return 'MID';
    case 'back':   return 'BOT';
  }
}
